import { useIsTabletOrMobileScreenSize } from '@app/utils/media-query';
import { TagManager } from '@app/utils/tag-manager';
import { Dialog, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import cls from 'classnames';
import React from 'react';
import classes from './styles.module.css';

type Props = {
  username: string;
  isVisible: boolean;
  onContinueClick: () => void;
  orderLink: string;
};

export default function SendOrderModal({ isVisible, onContinueClick, username, orderLink }: Props) {
  const isMobile = useIsTabletOrMobileScreenSize();

  return (
    <Dialog open={isVisible}>
      <DialogTitle style={{ paddingBottom: 0 }}>Atenção, {username}!</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Assim que seu WhatsApp abrir você precisa clicar no botão de enviar mensagem para concluir seu pedido.
        </DialogContentText>
        {isMobile ? (
          <img width="100%" src="/static/mobile-order-instructions.gif" style={{ objectFit: 'contain' }} />
        ) : (
          <img width="100%" src="/static/desktop-order-instructions.gif" style={{ objectFit: 'contain' }} />
        )}
        <a href={orderLink} target="_blank" className={TagManager.Classes.Purchase}>
          <button onClick={onContinueClick} className={cls(classes.continueButton, TagManager.Classes.Purchase)}>
            Continuar
          </button>
        </a>
      </DialogContent>
    </Dialog>
  );
}
